export default __webpack_public_path__ + "static/media/inventMgmt4Full.b19e24f1.png";